import store from '@/store/store.js'

export default item => {
  return Object.assign({}, item, {
    device: getDevice(item)
  })
}

const getDevice = (item) => {
  let child = store.getters['children/getById'](item.user_id)

  if (!child || !item.device_id || !child.devices) {
    return null
  }

  return child.devices.find(device => device.id === item.device_id)
}